// Shared broker formatters. Deliberately NOT
// utils/format.formatDate — that one renders seconds and 'not set'; the broker
// spec wants minute precision with a raw-string fallback. Kept in the batches
// feature until a shared brokers module exists to hoist them into.

const BROKER_DATE_FORMAT = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

/** "02 Aug 2026, 14:05" — unparseable input falls back to the raw string. */
export const formatBrokerDateTime = (value: string | undefined): string => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return BROKER_DATE_FORMAT.format(date);
};

const AMOUNT_FRACTION_DIGITS = 2;

/**
 * Batch money totals are NUMBERS, unlike the decimal-string transaction
 * `amount` fields which render verbatim.
 * 2 dp en-GB with the `—` NaN/nullish guard.
 */
export const formatAmount = (value: number | null | undefined): string => {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return value.toLocaleString('en-GB', { minimumFractionDigits: AMOUNT_FRACTION_DIGITS, maximumFractionDigits: AMOUNT_FRACTION_DIGITS });
};
